import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localisedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import 'dayjs/locale/en-gb';

dayjs.locale('en-gb');
dayjs.extend(utc);
dayjs.extend(localisedFormat);
dayjs.extend(localeData);
